/******************************************************************************************
 *	Default Response Transformer
 *******************************************************************************************
 *
 * Applies all default $http response transformers to passed-in argument.
 * This is required when specifying the `transformResponse` property directly on an $http instance
 * because otherwise it doesn't apply the default ones which, amongst other things, deserialized
 * the data.
 *
 */
(function() {
  

  angular.module('rcServices.defaultResponseTransformer', []).service(
    'DefaultResponseTransformer',
    /* @ngInject */
    function(_, $http) {
      this.processData = function(responseData, headers) {
        let data = responseData;
        if ($http.defaults.transformResponse && $http.defaults.transformResponse.length) {
          _.forEach($http.defaults.transformResponse, function(fn) {
            data = fn(data, headers);
          });
        }

        return data;
      };
    }
  );
})();
